module.exports = "/static/images/texture-forest.webp";